import { useAppSelector } from "../../index";

export const useLanguage = () => {
  return useAppSelector((state) => state.common.language);
};

export const useError = () => {
  return useAppSelector((state) => state.common.error);
}